import React from 'react';
import { FileText, ShoppingBag, CreditCard, Truck, RotateCcw, AlertCircle, Mail, Phone, Shield } from 'lucide-react';
import { BUSINESS } from '../config/businessInfo';
import BusinessLegalSummary from '../components/layout/BusinessLegalSummary';

const DistanceSelling = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
            <FileText className="h-8 w-8 text-orange-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Mesafeli Satış Sözleşmesi</h1>
          <p className="text-gray-600">
            Son güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <p className="text-sm text-gray-500 mt-2">
            6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği'ne uygundur.
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 space-y-8">
          
          {/* Satıcı Bilgileri */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <ShoppingBag className="h-6 w-6 text-orange-600 mr-2" />
              1. SATICI BİLGİLERİ
            </h2>
            <div className="bg-gray-50 rounded-lg p-6">
              <BusinessLegalSummary className="text-gray-700" />
            </div>
          </section>

          {/* Tanımlar */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. TANIMLAR
            </h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li><strong>Mesafeli Satış Sözleşmesi:</strong> Tüketicinin ve satıcının aynı anda fiziksel olarak hazır bulunmadığı, mal veya hizmetin tüketiciye ulaştırılması için uygun araçlarla yapılan sözleşmelerdir.</li>
              <li><strong>Tüketici:</strong> Bu sözleşme kapsamında satın alınan ürünleri ticari veya mesleki olmayan amaçlarla edinen gerçek veya tüzel kişidir.</li>
              <li><strong>Ürün:</strong> Web sitemiz üzerinden satışa sunulan tüm mal ve hizmetlerdir.</li>
              <li><strong>Sipariş:</strong> Tüketicinin web sitesi üzerinden yaptığı satın alma talebidir.</li>
            </ul>
          </section>

          {/* Sözleşmenin Konusu */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <FileText className="h-6 w-6 text-orange-600 mr-2" />
              3. SÖZLEŞMENİN KONUSU
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu sözleşme, Tüketicinin LeaserTech web sitesi üzerinden elektronik ortamda satışa sunulan ürünlerden birini veya birkaçını seçerek sipariş vermesi, 
              Satıcının da bu siparişi kabul etmesi suretiyle taraflar arasında kurulan mesafeli satış sözleşmesinin şartlarını belirlemektedir.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Sözleşme konusu ürünlerin özellikleri, satış fiyatı ve ödeme şekli hakkında bilgiler, web sitemizde her ürünün sayfasında açıkça belirtilmiştir.
            </p>
          </section>

          {/* Sipariş ve Ödeme */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <CreditCard className="h-6 w-6 text-orange-600 mr-2" />
              4. SİPARİŞ VE ÖDEME
            </h2>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">4.1. Sipariş Süreci</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Tüketici, web sitemiz üzerinden istediği ürünleri sepetine ekleyebilir.</li>
                  <li>Sipariş tamamlanmadan önce ürün bilgileri, fiyatı ve toplam tutar ekranda gösterilir.</li>
                  <li>Tüketici, sipariş bilgilerini kontrol edip onayladıktan sonra ödeme işlemini tamamlar.</li>
                  <li>Sipariş onayı, ödeme işleminin başarıyla tamamlanması ile gerçekleşir.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">4.2. Ödeme Yöntemleri</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Kredi kartı / Banka kartı (Visa, MasterCard) - iyzico güvenli ödeme altyapısı ile</li>
                  <li>Banka havalesi / EFT (onay sonrası gönderim yapılır)</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">4.3. Fiyat Bilgileri</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Tüm fiyatlar Türk Lirası (₺) cinsinden belirtilmiştir ve KDV dahildir.</li>
                  <li>Ürün fiyatları, sipariş verildiği tarihte geçerli olan fiyatlardır.</li>
                  <li>Kargo ücreti, sepet tutarına ve teslimat yöntemine göre belirlenir.</li>
                  <li>300₺ ve üzeri siparişlerde kargo ücretsizdir.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Teslimat */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <Truck className="h-6 w-6 text-orange-600 mr-2" />
              5. TESLİMAT
            </h2>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">5.1. Teslimat Süresi</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Standart teslimat: Sipariş onayından sonra 1-3 iş günü içinde kargoya verilir.</li>
                  <li>Hızlı teslimat (İstanbul içi): Sipariş onayından sonra 1-4 saat içinde teslimat yapılır (ek ücretli).</li>
                  <li>Hafta sonları ve resmi tatillerde kargo işlemleri yapılmaz.</li>
                  <li>Teslimat süresi, stok durumuna ve adres bilgilerine bağlı olarak değişebilir.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">5.2. Teslimat Yeri</h3>
                <p className="mb-2">
                  Ürünler, sipariş formunda belirtilen teslimat adresine gönderilir. Tüketici, adres bilgilerinin doğru olduğundan emin olmalıdır.
                </p>
                <p>
                  Yanlış veya eksik adres bilgisi nedeniyle ürünün ulaşmaması durumunda, Satıcı sorumlu tutulamaz.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">5.3. Teslimat ve Riskin Devri</h3>
                <p>
                  Ürünler, kargo firmasına teslim edildikten sonra risk Tüketiciye geçer. 
                  Ürünün hasarlı, eksik veya hatalı teslim edilmesi durumunda, kargo firmasına tutanak tutturulmalı ve 
                  derhal müşteri hizmetlerimize bildirilmelidir.
                </p>
              </div>
            </div>
          </section>

          {/* Cayma Hakkı */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <RotateCcw className="h-6 w-6 text-orange-600 mr-2" />
              6. CAYMA HAKKI
            </h2>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4">
              <p className="text-blue-800 font-semibold">
                <AlertCircle className="h-5 w-5 inline mr-2" />
                Tüketici, 6502 sayılı Tüketicinin Korunması Hakkında Kanun uyarınca, ürünün kendisine veya gösterdiği adresteki kişiye tesliminden itibaren 14 gün içinde cayma hakkını kullanabilir.
              </p>
            </div>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">6.1. Cayma Hakkının Kullanımı</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Cayma hakkını kullanmak için, müşteri hizmetlerimize ({BUSINESS.emailInfo}, {BUSINESS.emailContact} veya {BUSINESS.phone}) yazılı olarak bildirim yapılmalıdır.</li>
                  <li>Cayma bildirimi, 14 günlük sürenin dolmasından önce yapılmalıdır.</li>
                  <li>Cayma bildirimi sonrası, ürün orijinal ambalajı ve faturası ile birlikte 14 gün içinde iade edilmelidir.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">6.2. İade Koşulları</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Ürün, kullanılmamış, açılmamış ve orijinal ambalajında olmalıdır.</li>
                  <li>Ürünün değer kaybına neden olacak şekilde kullanılması durumunda, cayma hakkı kullanılamaz.</li>
                  <li>Kişiye özel hazırlanan, hızlı bozulan veya son kullanma tarihi geçmiş ürünlerde cayma hakkı bulunmamaktadır.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">6.3. İade Masrafları</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>İade kargo ücreti, ürün hatası veya yanlış ürün gönderilmesi durumunda Satıcıya aittir.</li>
                  <li>Diğer durumlarda iade kargo ücreti Tüketiciye aittir.</li>
                </ul>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">6.4. İade İşlemleri</h3>
                <p>
                  İade edilen ürünün kontrolünden sonra, ödeme yöntemi ne olursa olsun, iade bedeli 10 iş günü içinde 
                  Tüketiciye iade edilir. İade işlemi, ürünün iade koşullarını sağladığının tespit edilmesinden sonra başlar.
                </p>
              </div>
            </div>
          </section>

          {/* Garanti ve Değişim */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
              <Shield className="h-6 w-6 text-orange-600 mr-2" />
              7. GARANTİ VE DEĞİŞİM
            </h2>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">7.1. Garanti</h3>
                <p>
                  Tüm ürünlerimiz, üretici firma garantisi kapsamındadır. Garanti süresi ve koşulları, ürünün özelliklerine göre değişiklik gösterebilir. 
                  Garanti bilgileri, ürün sayfasında ve ürün ambalajında belirtilmiştir.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">7.2. Arızalı veya Hatalı Ürün</h3>
                <p className="mb-2">
                  Ürün teslim alındıktan sonra arızalı veya hatalı olduğu tespit edilirse, derhal müşteri hizmetlerimize bildirilmelidir. 
                  Gerekli kontroller yapıldıktan sonra:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Ürün değişimi yapılır veya</li>
                  <li>Tamiri mümkünse tamir edilir veya</li>
                  <li>İade ve iadesiz iptal işlemi gerçekleştirilir</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Genel Hükümler */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. GENEL HÜKÜMLER
            </h2>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">8.1. Bilgilendirme</h3>
                <p>
                  Tüketici, sipariş verdiği ürünün teknik özelliklerini, kullanım talimatlarını ve garanti koşullarını 
                  ürün sayfasından ve ürün ambalajından öğrenebilir.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">8.2. Sorumluluk</h3>
                <p>
                  Satıcı, ürünün sözleşmeye uygun tesliminden sorumludur. Satıcının kontrolü dışındaki nedenlerden kaynaklanan 
                  gecikmelerden ve zararlardan sorumlu tutulamaz.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">8.3. Uyuşmazlıkların Çözümü</h3>
                <p className="mb-2">
                  Bu sözleşmeden kaynaklanan uyuşmazlıkların çözümünde, Türkiye Cumhuriyeti yasaları uygulanır. 
                  İstanbul Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.
                </p>
                <p>
                  Tüketici, sorunlarını öncelikle müşteri hizmetlerimize ({BUSINESS.emailInfo}) bildirerek çözmeyi denemelidir.
                </p>
              </div>
            </div>
          </section>

          {/* İletişim */}
          <section className="bg-orange-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <Mail className="h-5 w-5 text-orange-600 mr-2" />
              İletişim ve Destek
            </h2>
            <div className="space-y-2 text-gray-700">
              <div className="flex items-center">
                <Mail className="h-4 w-4 text-orange-600 mr-2" />
                <span><strong>E-posta:</strong> {BUSINESS.emailInfo}, {BUSINESS.emailContact}</span>
              </div>
              <div className="flex items-center">
                <Phone className="h-4 w-4 text-orange-600 mr-2" />
                <span><strong>Telefon:</strong> {BUSINESS.phone}</span>
              </div>
              <p className="text-sm text-gray-600 mt-4">
                Herhangi bir sorunuz veya şikayetiniz için müşteri hizmetlerimizle iletişime geçebilirsiniz. 
                Çalışma saatlerimiz: Pazartesi - Cuma: 09:00 - 18:00
              </p>
            </div>
          </section>

        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>
            Bu sözleşme, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümlerine uygun olarak hazırlanmıştır.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DistanceSelling;




